import React, { useEffect, useRef, useState } from 'react';
import ModuleLayout from './ModuleLayout';
import useFetch from '../../api/useFetch';
import {
  Box,
  Button,
  Dialog,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useTheme,
} from '@mui/material';
import { API_DELETE, DBRequest, useConfig } from '../../api/api';
import { tokens } from '../../global/theme/tokens';
import { TimeLabel } from '../label/TimeLabel.jsx';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import ExoInfiniteScroll from '../exo/ExoInfiniteScroll.jsx';
import { t } from 'i18next';
import { ExoCalPopper } from '../exo/cal/ExoCalPopper.jsx';
import { updateOrCreate } from '../special/updateOrCreate.js';
import Feedback from '../special/Feedback.jsx';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { ExoCalList } from '../exo/cal/cal-list/ExoCalList.jsx';
import Cookies from 'universal-cookie';
import ExoAlert from '../exo/ExoAlert.jsx';

export const DashboardUpcomingEvents = ({ rowSpan, colSpan }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const config = useConfig();

  const cookies = new Cookies();
  const userId = cookies.get('userId');

  const { apiData, setApiData } = useFetch('modules/upcoming-events');
  const [groupedEvents, setGroupedEvents] = useState(null);
  const scrollContainerRef = useRef(null);
  const [allEvents, setAllEvents] = useState([]);
  const [calendars, setCalendars] = useState(null);

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleFeedback(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  // click actions
  const [editMode, setEditMode] = useState(false);
  const [selectionData, setSelectionData] = useState(null);
  const [popperOpen, setPopperOpen] = useState(false);
  const [expandCalendars, setExpandCalendars] = useState(false);
  const [openAlert, setOpenAlert] = useState(null);
  const hiddenCals = cookies.get('hiddenCals');

  // popper
  const [popperAnchor, setPopperAnchor] = useState(null);
  function handleOpenPopper(e, event) {
    setPopperOpen(true);
    setEditMode(false);
    setSelectionData(event);
    if (e) setPopperAnchor(e.currentTarget);
  }

  function handleClosePopper() {
    setPopperOpen(false);
    setSelectionData(null);
  }

  // When apiData changes
  useEffect(() => {
    if (apiData) {
      const { calendars } = apiData.data;
      updateCalendarsByCookies(calendars);
    }
  }, [apiData]);

  // When calendars change
  useEffect(() => {
    if (calendars) {
      updateCalendarEvents(calendars);
    }
  }, [calendars]);

  function updateCalendarsByCookies(updatedCals) {
    if (hiddenCals) {
      hiddenCals.forEach((id) => {
        const match = updatedCals.find((cal) => String(cal.id) === String(id));
        if (match) {
          match.isInactive = true;
        }
      });
    }
    setCalendars(updatedCals);
  }

  function updateCalendarEvents(calendars) {
    setGroupedEvents(groupEventsByDay(apiData.data.events, calendars));
  }

  function handleHiddenCalsChange(data) {
    setCalendars(data);
    updateCalendarEvents(data);
  }

  function handleUpdate(res) {
    const newEvents = updateOrCreate(allEvents, res);
    setAllEvents(newEvents);
    setGroupedEvents(groupEventsByDay(newEvents, apiData.data.calendars));
  }

  //Delete Calendar
  function handleCalDelete(cal, cals) {
    if (cal.shouldSync)
      return setOpenAlert({
        type: 'warning',
        message: t('Should the Calender be deleted from Google too?'),
        submitLabel: t('Yes'),
        cancelLabel: t('No'),
        onSubmit: () => deleteRequest(cal, cals, true),
        onCancel: () => deleteRequest(cal, cals, false),
      });
    else {
      DBRequest({
        config,
        path: `calendars/${cal.id}`,
        method: API_DELETE,
        onResponse: () => {
          handleDeletedCal(cal, cals);
        },
      });
    }
  }

  function deleteRequest(cal, cals, deleteOnGoogle) {
    setOpenAlert(null);
    DBRequest({
      config,
      path: `calendars/${cal.id}?deleteOnGoogle=${deleteOnGoogle}`,
      method: API_DELETE,
      onResponse: () => {
        handleDeletedCal(cal, cals);
      },
    });
  }

  function handleDeletedCal(cal, cals) {
    var newCalendars = cals.filter((obj) => obj.id !== cal.id);
    setCalendars(newCalendars);
  }

  // prepair data
  // function groupEventsByDay(events, calendars) {
  //   // Prepare calendarIdMap
  //   var calendarIdMap = {};

  //   calendars.forEach((calendar) => {
  //     calendarIdMap[calendar.id] = calendar;
  //   });

  //   console.log('Events are: ', events);
  //   // Create event arrays mapped by day
  //   const daysMap = new Map();
  //   const today = moment().startOf('day'); // Today

  //   events.forEach((event) => {
  //     let start = moment(event.startDateTime);
  //     const end = moment(event.endDateTime);

  //     // If event start is before today, reset start to today (filter previous days)
  //     if (start.isBefore(today, 'day')) {
  //       start = today.clone();
  //     }

  //     let currentDay = start.clone();

  //     while (currentDay.isSameOrBefore(end, 'day')) {
  //       const day = currentDay.format('DD');
  //       const month = t(currentDay.format('MMMM'));
  //       const weekDay = t(currentDay.format('dddd'));
  //       const dayKey = `${weekDay}, ${day}. ${month}`;

  //       // today or tomorrow label
  //       const todayDiff = currentDay.diff(today, 'days');
  //       const label =
  //         todayDiff === 0
  //           ? t('today')
  //           : todayDiff === 1
  //           ? t('tomorrow')
  //           : dayKey;

  //       if (!daysMap.has(dayKey)) {
  //         daysMap.set(dayKey, {
  //           day: currentDay.format('YYYY-MM-DD'),
  //           label,
  //           wholeDayEvents: [],
  //           normalEvents: [],
  //         });
  //       }

  //       const dayEntry = daysMap.get(dayKey);

  //       const calendarId = event.calendarId;
  //       const calendar = calendarIdMap[calendarId];

  //       // Only include events from non-hidden calendars
  //       if (!calendar?.isInactive) {
  //         dayEntry[event.wholeDay ? 'wholeDayEvents' : 'normalEvents'].push({
  //           ...event,
  //           calendar,
  //           color: calendar?.color,
  //         });
  //       }

  //       currentDay.add(1, 'day');
  //     }
  //   });

  //   // Filter out empty days
  //   const filteredDays = Array.from(daysMap.values()).filter(
  //     (entry) =>
  //       entry.wholeDayEvents.length > 0 || entry.normalEvents.length > 0
  //   );

  //   // Sort normal events by startDateTime for each day
  //   filteredDays.forEach((entry) => {
  //     entry.normalEvents.sort(
  //       (a, b) =>
  //         moment(a.startDateTime).valueOf() - moment(b.startDateTime).valueOf()
  //     );
  //   });
  //   return filteredDays;
  // }

  function groupEventsByDay(events, calendars) {
    const calendarIdMap = {};
    calendars.forEach((calendar) => {
      calendarIdMap[calendar.id] = calendar;
    });

    const userCalendarIds = calendars?.map((cal) => cal.id) || [];
    const today = moment().startOf('day'); //today
    const daysMap = new Map();

    events.forEach((event) => {
      let start = moment(event.startDateTime);
      const end = moment(event.endDateTime);
      // If event start is before today, reset start to today (filter previous days)
      if (start.isBefore(today, 'day')) {
        start = today.clone();
      }

      let currentDay = start.clone();

      while (currentDay.isSameOrBefore(end, 'day')) {
        const day = currentDay.format('DD');
        const month = t(currentDay.format('MMMM'));
        const weekDay = t(currentDay.format('dddd'));
        const dayKey = `${weekDay}, ${day}. ${month}`;
        // today or tomorrow label
        const todayDiff = currentDay.diff(today, 'days');

        const label =
          todayDiff === 0
            ? t('today')
            : todayDiff === 1
            ? t('tomorrow')
            : dayKey;

        if (!daysMap.has(dayKey)) {
          daysMap.set(dayKey, {
            day: currentDay.format('YYYY-MM-DD'),
            label,
            wholeDayEvents: [],
            normalEvents: [],
          });
        }

        const dayEntry = daysMap.get(dayKey);
        const calendarId = event.calendarId;
        const calendar = calendarIdMap[calendarId];

        const ownerMatch = String(event.ownerId) === String(userId);
        const calendarMatch = userCalendarIds.includes(event.userCalendar?.id);

        const eventAlreadyExists = [
          ...dayEntry.wholeDayEvents,
          ...dayEntry.normalEvents,
        ].some((e) => e.id === event.id);

        if (
          !calendar?.isInactive &&
          (ownerMatch || calendarMatch) &&
          !eventAlreadyExists
        ) {
          const fullEvent = {
            ...event,
            calendar,
            color: calendar?.color,
          };

          if (event.wholeDay) {
            dayEntry.wholeDayEvents.push(fullEvent);
          } else {
            dayEntry.normalEvents.push(fullEvent);
          }
        }

        currentDay.add(1, 'day');
      }
    });
    // Filter out empty days
    const filteredDays = Array.from(daysMap.values()).filter(
      (entry) =>
        entry.wholeDayEvents.length > 0 || entry.normalEvents.length > 0
    );
    // Sort normal events by startDateTime for each day
    filteredDays.forEach((entry) => {
      entry.normalEvents.sort(
        (a, b) =>
          moment(a.startDateTime).valueOf() - moment(b.startDateTime).valueOf()
      );
    });
    return filteredDays;
  }

  function handleNextPage(res) {
    setApiData((prevApiData) => {
      const prevEvents = prevApiData?.data?.events || [];
      const newEvents = res.data.events || [];

      // Filter to only events not already in prevEvents by ID
      const uniqueNewEvents = newEvents.filter(
        (event) => !prevEvents.some((e) => e.id === event.id)
      );

      const updatedAllEvents = [...prevEvents, ...uniqueNewEvents];

      // Update grouped events based on combined events and calendars
      const newGroupedEvents = groupEventsByDay(
        updatedAllEvents,
        res.data.calendars
      );

      // Update your UI states
      setGroupedEvents(newGroupedEvents);
      setAllEvents(updatedAllEvents);

      // Return updated apiData with combined events
      return {
        ...res,
        data: {
          ...res.data,
          events: updatedAllEvents,
        },
      };
    });
  }

  // To delete an event
  function handleDelete(eventId) {
    const newEvents = allEvents.filter((obj) => obj.id !== eventId);
    setAllEvents(newEvents);
    setApiData({ ...apiData, events: newEvents });
  }

  // event interaction
  function handleEventEdit(e, event) {
    if (!event.writePermissions) return;
    setPopperOpen(true);
    setSelectionData(event);
    setEditMode(true);
  }

  return (
    <ModuleLayout
      colSpan={colSpan}
      rowSpan={rowSpan}
      label={t('Upcoming Events')}
    >
      <Box className="flex w-full overflow-hidden">
        <Dialog
          open={expandCalendars}
          onClose={() => setExpandCalendars(false)}
          anchor="right"
          sx={{
            '.MuiPaper-root': {
              backgroundImage: 'unset!important',
            },
            '.MuiBackdrop-root': {
              backdropFilter: 'blur(1px)',
              backgroundColor: 'rgba(0, 0, 0, 0.3 )',
            },
          }}
        >
          <ExoCalList
            calendars={calendars}
            onChange={handleHiddenCalsChange}
            onDelete={handleCalDelete}
          />
        </Dialog>
        <Box
          className="flex w-full absolute right-4 top-2"
          sx={{
            display: 'flex',
            justifyContent: 'right',
          }}
        >
          <Button
            onClick={() => setExpandCalendars(!expandCalendars)}
            sx={{
              margin: '0px',
              padding: '4px',
              bgcolor: colors.glass,
              ':hover': {
                bgcolor: colors.selected,
              },
              borderRadius: '8px',
              minWidth: '45px',
            }}
            className=" backdrop-blur-md"
          >
            <CalendarMonthIcon />
          </Button>
        </Box>
      </Box>
      <Box
        ref={scrollContainerRef}
        className="flex flex-col h-full overflow-y-auto"
      >
        {apiData && (
          <ExoInfiniteScroll
            scrollContainerRef={scrollContainerRef}
            apiData={apiData}
            onResponse={handleNextPage}
            className="flex flex-col gap-4"
            triggerDist={200}
          >
            {groupedEvents?.map((group) => (
              <Box key={group.day}>
                <Typography
                  fontSize={11}
                  fontWeight={500}
                  className="opacity-70"
                  sx={{
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    whiteSpace: 'normal',
                  }}
                >
                  {group.label}
                </Typography>
                <Box className="flex flex-col gap-1 pr-1">
                  {group.wholeDayEvents?.map((event) => (
                    <ShowEvent
                      key={event.id}
                      event={event}
                      day={group.day}
                      onClick={(e) => handleOpenPopper(e, event)}
                      onDoubleClick={(e) => handleEventEdit(e, event)}
                    />
                  ))}
                  {group.normalEvents?.map((event) => (
                    <ShowEvent
                      key={event.id}
                      event={event}
                      day={group.day}
                      onClick={(e) => handleOpenPopper(e, event)}
                      onDoubleClick={(e) => handleEventEdit(e, event)}
                    />
                  ))}
                </Box>
              </Box>
            ))}
          </ExoInfiniteScroll>
        )}
      </Box>
      {apiData && (
        <ExoCalPopper
          anchorEl={popperAnchor}
          open={popperOpen}
          onClose={handleClosePopper}
          data={selectionData}
          calendars={calendars}
          onFeedback={handleFeedback}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
          editMode={editMode}
          setEditMode={setEditMode}
        />
      )}
      <Feedback state={alertState} setState={setAlertState} />
      <ExoAlert
        open={Boolean(openAlert)}
        alert={openAlert || {}}
        onClose={openAlert?.onCancel}
        onSubmit={openAlert?.onSubmit}
      />
    </ModuleLayout>
  );
};

export const ShowEvent = ({
  event,
  day,
  onClick,
  selectedData,
  onDoubleClick,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const isStartDay =
    moment(day)
      .startOf('day')
      .diff(moment(event.startDateTime).startOf('day'), 'days') === 0;
  const isEndDay =
    moment(day)
      .startOf('day')
      .diff(moment(event.endDateTime).startOf('day'), 'days') === 0;

  const { label, location, wholeDay } = event;

  const isWholeDay = (!isStartDay && !isEndDay) || wholeDay;

  const isSelected = selectedData?.id === event.id;

  return (
    <Box
      onClick={onClick}
      onDoubleClick={event.calendar?.id ? onDoubleClick : null}
      className=" rounded-lg w-full h-[34px] relative flex items-center pl-2 cursor-pointer"
      sx={{
        bgcolor: isSelected ? colors.info + '20' : event.calendar?.color + '20',
        border: `1px solid ${isSelected ? colors.info : 'transparent'}`,
        ':hover': {
          border: `1px solid ${colors.info}`,
          bgcolor: colors.info + '20',
        },
      }}
    >
      <Box className="w-[5px] h-full flex items-center justify-center">
        <Box
          sx={{
            bgcolor: event.calendar?.color,
          }}
          className="rounded-full w-[4px] h-[60%]"
        />
      </Box>
      <Box className="h-full w-full pl-2 pr-3 flex justify-between items-center py-1 gap-1 overflow-hidden">
        <Box className="block w-full overflow-hidden ">
          <Typography
            fontSize={14}
            fontWeight={500}
            className=" whitespace-nowrap text-ellipsis w-full overflow-hidden"
          >
            {label}
          </Typography>
          {location && (
            <Typography
              fontSize={10}
              fontWeight={500}
              className=" whitespace-nowrap text-ellipsis w-full overflow-hidden opacity-50"
              marginTop={'-5px'}
            >
              {`${location.street} ${location.houseNumber} - ${location.zipCode} ${location.city}`}
            </Typography>
          )}
        </Box>
        {isWholeDay ? (
          <Typography fontSize={11} fontWeight={500}>
            {t('All day')}
          </Typography>
        ) : (
          <Typography
            fontSize={11}
            className="flex flex-col h-full justify-center monospace"
            sx={{
              span: {
                height: '12px',
                lineHeight: '12px',
              },
            }}
            textAlign="right"
          >
            <span style={{ fontWeight: 500 }}>
              {isStartDay && (
                <TimeLabel time={event.startDateTime} format="HH:mm" />
              )}
              {!isStartDay && isEndDay && t('End')}
            </span>

            <span
              style={{
                opacity: isEndDay ? 0.5 : 0,
              }}
            >
              <TimeLabel time={event.endDateTime} format="HH:mm" />
            </span>
          </Typography>
        )}
      </Box>
    </Box>
  );
};
